import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "bots-page" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "section" }
const _hoisted_4 = { class: "section-header" }
const _hoisted_5 = { class: "section-title" }
const _hoisted_6 = { class: "section-actions" }
const _hoisted_7 = { class: "filter-btn" }
const _hoisted_8 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_9 = { class: "loading-text" }
const _hoisted_10 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_11 = { class: "empty-title" }
const _hoisted_12 = { class: "empty-description" }
const _hoisted_13 = {
  key: 2,
  class: "agents-grid"
}
const _hoisted_14 = { class: "agent-status" }
const _hoisted_15 = { class: "status-text" }
const _hoisted_16 = { class: "agent-avatar" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { class: "agent-content" }
const _hoisted_19 = { class: "agent-info" }
const _hoisted_20 = { class: "agent-department" }
const _hoisted_21 = { class: "agent-name" }
const _hoisted_22 = { class: "agent-description" }
const _hoisted_23 = { class: "description-section" }
const _hoisted_24 = { class: "description-header" }
const _hoisted_25 = { class: "description-title" }
const _hoisted_26 = { class: "description-text" }
const _hoisted_27 = { class: "agent-footer" }
const _hoisted_28 = {
  key: 3,
  class: "agents-list"
}
const _hoisted_29 = { class: "agent-list-avatar" }
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = { class: "agent-list-content" }
const _hoisted_32 = { class: "agent-list-header" }
const _hoisted_33 = { class: "agent-list-name" }
const _hoisted_34 = { class: "agent-list-department" }
const _hoisted_35 = { class: "agent-list-description" }
const _hoisted_36 = { class: "agent-list-actions" }
const _hoisted_37 = { class: "section marketplace-section" }
const _hoisted_38 = { class: "coming-soon-overlay" }
const _hoisted_39 = { class: "coming-soon-content" }
const _hoisted_40 = { class: "coming-soon-title" }
const _hoisted_41 = { class: "coming-soon-description" }
const _hoisted_42 = { class: "section-header" }
const _hoisted_43 = { class: "section-title" }
const _hoisted_44 = { class: "action-btn secondary-btn" }
const _hoisted_45 = { class: "marketplace-grid" }
const _hoisted_46 = { class: "marketplace-category" }
const _hoisted_47 = { class: "marketplace-avatar" }
const _hoisted_48 = ["src", "alt"]
const _hoisted_49 = { class: "marketplace-content" }
const _hoisted_50 = { class: "marketplace-name" }
const _hoisted_51 = { class: "marketplace-description" }
const _hoisted_52 = { class: "marketplace-features" }
const _hoisted_53 = { class: "marketplace-footer" }
const _hoisted_54 = { class: "marketplace-price" }
const _hoisted_55 = { class: "add-agent-btn" }

import { ref, computed, onMounted } from 'vue';
import { useI18n } from "vue-i18n";
import { supabase } from '@/lib/supabaseClient';
import { getCurrentOrgId } from '@/utils/getCurrentOrgId';
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";

// Type definition for translation objects
type TranslationObject = {
  [key: string]: string | TranslationObject;
};

interface AgentStat {
  label: string;
  value: string;
  icon?: string;
}

interface Agent {
  id: string;
  name: string;
  icon?: string;
  image?: string;
  iconClasses?: string;
  gradientClass?: string;
  statusClass?: string;
  stat1: AgentStat;
  stat2: AgentStat;
  stat3: AgentStat;
  linkedTo: string;
  department: string;
  description: string;
  roles: string[];
}

interface MarketplaceAgent {
  name: string;
  icon?: string;
  image?: string;
  iconClasses?: string;
  gradientClass?: string;
  category: string;
  description: string;
  features: string[];
  price: string;
}

// Reactive agents data from Supabase

export default /*@__PURE__*/_defineComponent({
  __name: 'MyBotsPage',
  setup(__props) {

const searchQuery = ref('');
const isGridView = ref(true);
const loading = ref(false);

const toggleView = () => {
  isGridView.value = !isGridView.value;
};

// i18n
const { locale } = useI18n();

// Translation files
const translationFiles = {
  en: enTranslations,
  he: heTranslations,
  ar: arTranslations
};

// Direct translation function that bypasses vue-i18n
const directT = (key: string): string => {
  const parts = key.split('.');
  let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
  
  for (const part of parts) {
    if (!result || !(part in result)) {
      console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
      // Fallback to English if translation not found
      let enResult: TranslationObject = translationFiles.en;
      for (const fallbackPart of parts) {
        if (!enResult || !(fallbackPart in enResult)) return key;
        enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
      }
      return typeof enResult === 'string' ? enResult : key;
    }
    result = result[part as keyof typeof result] as TranslationObject;
  }
  return typeof result === 'string' ? result : key;
};



const agentsData = ref<Agent[]>([]);

// Function to get random gradient class
const getRandomGradientClass = () => {
  const gradients = ['gradient-primary', 'gradient-purple', 'gradient-info', 'gradient-success', 'gradient-warning', 'gradient-teal'];
  return gradients[Math.floor(Math.random() * gradients.length)];
};

// Function to get random department
const getRandomDepartment = () => {
  const departments = ['Personal', 'Sales', 'Customer Service', 'Sales and Marketing', 'Finance and Accounts'];
  return departments[Math.floor(Math.random() * departments.length)];
};

// Function to get random image
const getRandomImage = () => {
  const images = [
    '/images/bots/personal-assistant.png',
    '/images/bots/followup.png',
    '/images/bots/secretary.png',
    '/images/bots/customer-service.png',
    '/images/bots/sales.png',
    '/images/bots/finance.png'
  ];
  return images[Math.floor(Math.random() * images.length)];
};

// Fetch agents from Supabase
const fetchAgents = async () => {
  try {
    loading.value = true;
    
    // Get current organization ID
    const orgId = await getCurrentOrgId();
    if (!orgId) {
      console.error('No organization ID found');
      return;
    }

    const { data, error } = await supabase
      .from('agents')
      .select('*')
      .eq('organization_id', orgId)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching agents:', error);
      return;
    }

    // Map Supabase data to Agent interface
    agentsData.value = data?.map((agent: any) => ({
      id: agent.id,
      name: agent.bot_name_value || 'Unnamed Agent',
      image: getRandomImage(), // Keep random images as requested
      gradientClass: getRandomGradientClass(),
    statusClass: "bg-success-100 text-success-700",
    stat1: { 
      label: "Active Tasks",
        value: Math.floor(Math.random() * 50).toString(),
      icon: "ri-checkbox-circle-line"
    },
    stat2: { 
      label: "Response Time",
        value: `${(Math.random() * 3 + 1).toFixed(1)}s`,
      icon: "ri-flashlight-line"
    },
    stat3: { 
      label: "Accuracy",
        value: `${Math.floor(Math.random() * 10 + 90)}%`,
      icon: "ri-award-line"
    },
      linkedTo: agent.type || "General",
      department: getRandomDepartment(),
      description: agent.bot_description_value || 'AI Agent for various tasks and automation.',
      roles: [agent.type || "AI Assistant", "Task Manager", "Virtual Assistant"]
    })) || [];

  } catch (error) {
    console.error('Error fetching agents:', error);
  } finally {
    loading.value = false;
  }
};

// Fetch agents on component mount
onMounted(() => {
  fetchAgents();
});

const marketplaceAgents: MarketplaceAgent[] = [
  {
    name: "Data Analyst",
    image: "/images/bots/data-analyst.png",
    gradientClass: "gradient-purple",
    category: "Data Analysis",
    description: "Smart agent that analyzes business data and provides automated insights",
    features: [
      "Trend and Pattern Analysis",
      "Automated Reports",
      "Alerts for Outliers"
    ],
    price: "199₪ / Month"
  },
  {
    name: "Content Assistant",
    image: "/images/bots/content-assistant.png",
    gradientClass: "gradient-success",
    category: "Content",
    description: "Smart agent that creates and edits content marketing automatically",
    features: [
      "Blog Post Writing",
      "Editing Existing Content",
      "Target Audience Adaptation"
    ],
    price: "179₪ / Month"
  }
];

const filteredAgents = computed(() => {
  if (!searchQuery.value) return agentsData.value;
  return agentsData.value.filter(agent => 
    agent.name.includes(searchQuery.value) || 
    agent.department.includes(searchQuery.value)
  );
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "background-elements" }, [
      _createElementVNode("div", { class: "floating-orb orb-1" }),
      _createElementVNode("div", { class: "floating-orb orb-2" }),
      _createElementVNode("div", { class: "floating-orb orb-3" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-robot-2-line" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(directT('bots.yourAiTeam')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", _hoisted_7, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "ri-filter-3-line" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(directT('bots.filter')), 1)
            ]),
            _createElementVNode("button", {
              class: "view-toggle-btn",
              onClick: toggleView
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(isGridView.value ? 'ri-list-unordered' : 'ri-grid-line')
              }, null, 2)
            ])
          ])
        ]),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "loading-spinner" }, null, -1)),
              _createElementVNode("p", _hoisted_9, _toDisplayString(directT('bots.loading') || 'Loading agents...'), 1)
            ]))
          : (!loading.value && filteredAgents.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "empty-icon" }, [
                  _createElementVNode("i", { class: "ri-robot-line" })
                ], -1)),
                _createElementVNode("h3", _hoisted_11, _toDisplayString(directT('bots.noAgents') || 'No agents found'), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(directT('bots.noAgentsDescription') || 'Create your first AI agent to get started.'), 1)
              ]))
            : (isGridView.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAgents.value, (agent, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: agent.id,
                      class: "agent-card",
                      style: _normalizeStyle({ animationDelay: `${index * 0.1}s` })
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["agent-header", agent.gradientClass])
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "status-indicator active" }, null, -1)),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(directT('bots.status.active')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("img", {
                            src: agent.image || '/images/bots/default.png',
                            alt: agent.name
                          }, null, 8, _hoisted_17)
                        ])
                      ], 2),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(agent.department), 1),
                          _createElementVNode("h3", _hoisted_21, _toDisplayString(agent.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ri-information-line" }, null, -1)),
                              _createElementVNode("span", _hoisted_25, _toDisplayString(directT('bots.description')), 1)
                            ]),
                            _createElementVNode("p", _hoisted_26, _toDisplayString(agent.description), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_router_link, {
                            to: `/bots/settings/${agent.id}`,
                            class: _normalizeClass(["bot-settings-btn", agent.gradientClass])
                          }, {
                            default: _withCtx(() => [
                              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "ri-settings-4-line" }, null, -1)),
                              _createElementVNode("span", null, _toDisplayString(directT('bots.botSettings')), 1)
                            ]),
                            _: 2,
                            __: [6]
                          }, 1032, ["to", "class"])
                        ])
                      ])
                    ], 4))
                  }), 128))
                ]))
              : (!loading.value && filteredAgents.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAgents.value, (agent, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: agent.id,
                        class: "agent-list-item",
                        style: _normalizeStyle({ animationDelay: `${index * 0.1}s` })
                      }, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("img", {
                            src: agent.image || '/images/bots/default.png',
                            alt: agent.name
                          }, null, 8, _hoisted_30),
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "status-indicator active" }, null, -1))
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("h3", _hoisted_33, _toDisplayString(agent.name), 1),
                            _createElementVNode("span", _hoisted_34, _toDisplayString(agent.department), 1)
                          ]),
                          _createElementVNode("p", _hoisted_35, _toDisplayString(agent.description), 1)
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_router_link, {
                            to: `/bots/settings/${agent.id}`,
                            class: _normalizeClass(["bot-settings-btn-list", agent.gradientClass])
                          }, {
                            default: _withCtx(() => [
                              _cache[8] || (_cache[8] = _createElementVNode("i", { class: "ri-settings-4-line" }, null, -1)),
                              _createElementVNode("span", null, _toDisplayString(directT('bots.settings')), 1)
                            ]),
                            _: 2,
                            __: [8]
                          }, 1032, ["to", "class"])
                        ])
                      ], 4))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "coming-soon-icon" }, [
              _createElementVNode("i", { class: "ri-time-line" })
            ], -1)),
            _createElementVNode("h3", _hoisted_40, _toDisplayString(directT('bots.comingSoon.title')), 1),
            _createElementVNode("p", _hoisted_41, _toDisplayString(directT('bots.comingSoon.description')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("h2", _hoisted_43, [
            _cache[10] || (_cache[10] = _createElementVNode("i", { class: "ri-store-2-line" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(directT('bots.agentStore')), 1)
          ]),
          _createElementVNode("button", _hoisted_44, [
            _cache[11] || (_cache[11] = _createElementVNode("i", { class: "ri-external-link-line" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(directT('bots.visitFullStore')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(marketplaceAgents, (agent, index) => {
            return _createElementVNode("div", {
              key: index,
              class: "marketplace-card",
              style: _normalizeStyle({ animationDelay: `${index * 0.1}s` })
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["marketplace-header", agent.gradientClass])
              }, [
                _createElementVNode("div", _hoisted_46, _toDisplayString(agent.category), 1),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("img", {
                    src: agent.image,
                    alt: agent.name
                  }, null, 8, _hoisted_48)
                ])
              ], 2),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("h3", _hoisted_50, _toDisplayString(agent.name), 1),
                _createElementVNode("p", _hoisted_51, _toDisplayString(agent.description), 1),
                _createElementVNode("div", _hoisted_52, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agent.features.slice(0, 2), (feature, fIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: fIndex,
                      class: "feature-item"
                    }, [
                      _cache[12] || (_cache[12] = _createElementVNode("i", { class: "ri-checkbox-circle-line" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(feature), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, _toDisplayString(agent.price), 1),
                  _createElementVNode("button", _hoisted_55, [
                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "ri-add-line" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(directT('bots.add')), 1)
                  ])
                ])
              ])
            ], 4)
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})